<template>
<div class=" p-3 bg-white">
  <div class="row text-center ">

      <div class=" col-lg-6 ">
        <img class="img-fluid col-lg-8 " src="../../../../public/order.webp">
      </div>
    <div class="col-lg-6">
        <div class="col-lg-12 text-primary mt-5 "><h3> {{paginationMeta.total}}</h3>
          <div class="col-lg-12 mt-3  text-dark"><h4>سفارشات من</h4></div>
        </div>
      </div>


  </div>
</div>

</template>
<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/orders/tableItems.vue";

export default {
  name: "my0rders",
  components: {TableLayout, Pagination, tableItems},
  mounted() {
    this.$store.dispatch("ShoppingCart/getOrders");
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getOrders",
      paginationMeta: "ShoppingCart/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      console.log("page", page);
      this.$store.dispatch("ShoppingCart/getOrders", page);
    },
  },
};
</script>
<style scoped>

.icon-dash-order{
  background: var(--light-primary);


}
</style>